"use strict";

const analyserV2pdf = function () {
    let promiseResolve, widgetPromise;
    const default_config = {
        "bank_statement_info": {},
        "templates": {},
        "html": {
            "config": {
                "account_info": {
                    "classes": {
                        "card_item": "owl-theme"
                    }
                },
                "transactions": {
                    "classes": {
                        "data_head": "data-head",
                        "data_left_fixed": "dataLeft-fixed",
                        "mid_panel": "mid-panel",
                        "data_row": "data-row"
                    }
                },
                "monthly_line_item": {
                    "classes": {
                        "card_item": "owl-theme"
                    }
                },
                "high_order_value": {
                    "classes": {
                        "card_item": "owl-theme"
                    }
                },
                "debt_analysis": {
                    "classes": {
                        "card_item": "owl-theme"
                    }
                },
                "trend_analysis": {
                    "classes": {
                        "card_item": "owl-theme"
                    }
                },
                "ebitda_schedule": {
                    "classes": {
                        "card_item": "owl-theme"
                    }
                }
            }
        },
        "owl_carousel": {
            "loop": false,
            "margin": 25,
            "nav": true,
            "responsive": {
                0: {
                    items: 1
                },
                600: {
                    items: 3
                },
                1000: {
                    items: 4
                }
            }
        },
        "_default_option": "All",
        "months": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        "_months": {
            "Jan": 1,
            "Feb": 2,
            "Mar": 3,
            "Apr": 4,
            "May": 5,
            "Jun": 6,
            "Jul": 7,
            "Aug": 8,
            "Sep": 9,
            "Oct": 10,
            "Nov": 11,
            "Dec": 12
        },
        "img_extension": ".jpg",
        "default_img": "defaultbank",
        "charts": {
            "transactions": {
                "width": 550,
                "height": 400,
                "margin": { top: 20, right: 10, bottom: 20, left: 30 },
                "bar_padding": 0.1,
                "bar_margin": 3,
                "axis_ticks": { qty: 5, outer_size: 0 },
                "color": {
                    "bars": {
                        "field1": "#47bff2"
                    }
                },
            },
            "consolidated_debt_analysis": {
                "x_axis": "model_name",
                "height": 320,
                "margin": { "top": 20, "right": 10, "bottom": 20, "left": 50 },
                "bar_padding": 0.5,
                "bar_margin": 10,
                "axis_ticks": { "qty": 12, "outer_size": 0 },
                "color": { "bars": {} },
            },
            "consolidated_monthly_activity": {
                "x_axis": "model_name",
                "height": 350,
                "margin": { "top": 20, "right": 10, "bottom": 20, "left": 50 },
                "bar_padding": 0.4,
                "bar_margin": 3,
                "chart1_keys": {
                    "model_name": "month_year",
                    "field1": "revenue",
                    "field2": "expense",
                    "field3": "avg_daily_balance",
                },
                "chart2_keys": {
                    "model_name": "month_year",
                    "field1": "transfer_in",
                    "field2": "transfer_out",
                },
                "axis_ticks": { "qty": 12, "outer_size": 0 }
            },
            "consolidated_trend_analysis": {
                "id": ".trend-analysis-graph",
                "offset_height": 300,
                "height": 350,
                "padding": 0,
                "duration": 250,
                "lineOpacity": "0.55",
                "lineOpacityHover": "0.85",
                "otherLinesOpacityHover": "0.1",
                "lineStroke": "1.5px",
                "lineStrokeHover": "2.5px",
                "circleOpacity": '0.85',
                "circleOpacityOnLineHover": "0.25",
                "circleRadius": 5,
                "circleRadiusHover": 6,
                "left": 6,
                "curve": true,
                "callback": "comparisionEvent",
            },
            "consolidated_monthly_line_item": {
                "config": {
                    "id": "#monthlyLineItemDebitChart",
                    "offset_height": 235,
                    "height": 350,
                    "margin": 40,
                    "duration": 250,
                    "lineOpacity": "0.55",
                    "lineOpacityHover": "0.85",
                    "otherLinesOpacityHover": "0.1",
                    "lineStroke": "1.5px",
                    "lineStrokeHover": "2.5px",
                    "circleOpacity": '0.85',
                    "circleOpacityOnLineHover": "0.25",
                    "circleRadius": 3,
                    "circleRadiusHover": 6,
                    "left": 8,
                    "curve": false,
                    "color": ["rgb(23, 140, 220)"],
                    "tooltip": {
                        "top": 10,
                        "left": 0,
                    },
                    "data": [
                        {
                            "name": "Debit",
                            "from": "left",
                        }
                    ]
                },
                "config1": {
                    "id": "#monthlyLineItemCreditChart",
                    "offset_height": 235,
                    "height": 350,
                    "margin": 50,
                    "duration": 250,
                    "lineOpacity": "0.55",
                    "lineOpacityHover": "0.85",
                    "otherLinesOpacityHover": "0.1",
                    "lineStroke": "1.5px",
                    "lineStrokeHover": "2.5px",
                    "circleOpacity": '0.85',
                    "circleOpacityOnLineHover": "0.25",
                    "circleRadius": 3,
                    "circleRadiusHover": 6,
                    "curve": false,
                    "color": ["rgb(23, 140, 220)"],
                    "tooltip": {
                        "top": 0,
                    },
                    "left": 652,
                    "data": [
                        {
                            "from": "left",
                            "name": "Credit",
                        }
                    ]
                }
            }
        },
        "table_divs": {
            "consolidated_monthly_activity": [
                {
                    "target": {
                        "header": "dataLeftFixedMonthlyActivity",
                        "row": "dataLeftFixedMonthlyActivity"
                    },
                    "columns": ["month_year"]
                },
                {
                    "target": {
                        "header": "data-head",
                        "row": "midPanelMonthlyActivity"
                    },
                    "row_parent": { "class": "data-row" },
                },
                {
                    "target": {
                        "header": "dataRightFixedMonthlyActivity",
                        "row": "dataRightFixedMonthlyActivity"
                    },
                    "columns": ["avg_daily_balance"]
                }
            ],
            "transactions": [
                {
                    "target": {
                        "header": "dataLeft-fixed",
                        "row": "dataLeft-fixed"
                    },
                    "columns": ["bank_name"]
                },
                {
                    "target": {
                        "header": "data-head",
                        "row": "mid-panel"
                    },
                    "row_parent": {
                        "class": "data-row",
                    },
                }
            ],
            "consolidated_trend_analysis": [
                {
                    "target": {
                        "header": "dataLeftFixedConsolidatedTrendAnalysis",
                        "row": "dataLeftFixedConsolidatedTrendAnalysis"
                    },
                    "columns": ["group"]
                },
                {
                    "target": {
                        "header": "midPanelDataHeadConsolidatedTrendAnalysis",
                        "row": "midPanelConsolidatedTrendAnalysis"
                    },
                    "row_parent": {
                        "class": "data-row"
                    }
                },
                {
                    "target": {
                        "header": "dataRightFixedConsolidatedTrendAnalysis",
                        "row": "dataRightFixedConsolidatedTrendAnalysis"
                    },
                    "columns": ["total"]
                }
            ],
            "consolidated_monthly_line_item": [
                {
                    "target": {
                        "header": "monthlyLineItemLeft",
                        "row": "monthlyLineItemLeft"
                    },
                    "columns": ["transaction"]
                },
                {
                    "target": {
                        "header": "monthlyLineItemLeft1",
                        "row": "monthlyLineItemLeft1"
                    },
                    "columns": ["category"]
                },
                {
                    "target": {
                        "header": "monthlyLineItemDataHead",
                        "row": "monthlyLineItemMidPanel"
                    },
                    "row_parent": {
                        "class": "data-row"
                    },
                }
            ]
        },
        "_consolidated_monthly_activity": {
            "graph1": {
                "color_codes": ["#158cdc", "#fe9006", "#079e89"],
                "legends": ["revenue", "operating_cost", "avg_daily_balance"],
                "legends_value": ["Revenue", "Total Operating Expense", "Average Daily Balance"],
            },
            "graph2": {
                "color_codes": ["#158cdc", "#fe9006"],
                "legends": ["transfer_in", "transfer_out"],
                "legends_value": ["Transfer In", "Transfer Out"],
            }
        },
        "_consolidated_trend_analysis": {
            "trend_analysis_graph": {
                "class": "trend-analysis-graph"
            },
            "comparision_filter_options": ["percentage_revenue", "percentage_expense", "percentage_debt", "percentage_transfer"],
            "is_left_card_on": true,
            "is_right_card_on": true,
            "last_selected_variable1_option": "revenue",
            "last_selected_variable2_option": "expense",
            "_default_option_config": {
                "callback": { "name": "separateNumberByDelimiterWithSignAndThousand" },
                "config": {
                    "header": { "class": "label-block" },
                    "row": { "class": "label-block" }
                }
            }
        },
        "_consolidated_debt_analysis": {
            "_default_option_config": {
                "callback": { "name": "separateNumberByDelimiterWithSignAndThousand" },
                "config": {
                    "header": { "class": "label-block" },
                    "row": { "class": "label-block" }
                }
            }
        },
        "_consolidated_monthly_line_item": {
            "_default_option_config": {
                "callback": { "name": "separateNumberByDelimiterWithSignAndThousand" },
                "config": {
                    "header": { "class": "label-block col" },
                    "row": { "class": "label-block col" }
                }
            }
        },
        "_ebitda_schedule": {
            "current_debt": 0,
            "future_debt": 0,
            "original": {
                "current_debt": 0,
                "future_debt": 0
            },
            "selected_option": "yearly",
            "proposed_debt_amount": {
                "value": 0
            },
            "current_selected_option": "yearly",
            "quarter_filter_option": ["monthly", "quarterly", "half", "yearly"],
            "DSCRSchedule": [
                {
                    "target": {
                        "header": "dscrScheduleDataLeftFixed",
                        "row": "dscrScheduleDataLeftFixed"
                    },
                    "columns": ["group"]
                },
                {
                    "target": {
                        "header": "dscrScheduleDataHead",
                        "row": "dscrScheduleMidPanel"
                    },
                    "row_parent": {
                        "class": "row data-row m-0"
                    },
                }
            ],
            "est_operating_profit_schedule": {
                "columns": {
                    "classification": {
                        "config": {
                            "header": {
                                "class": "col",
                            },
                            "row": {
                                "class": "col"
                            }
                        }
                    },
                    "group": {
                        "config": {
                            "header": {
                                "class": "col",
                            },
                            "row": {
                                "class": "col"
                            }
                        }
                    },
                    "average_monthly_cash_flow ($)": {
                        "config": {
                            "header": {
                                "class": "col-3",
                            },
                            "row": {
                                "class": "col-3"
                            }
                        }
                    },
                    "annual_cash_flow ($)": {
                        "config": {
                            "header": {
                                "class": "col",
                            },
                            "row": {
                                "class": "col"
                            }
                        }
                    }
                },
                "headers": ['classification', 'group', 'average_monthly_cash_flow ($)', 'annual_cash_flow ($)']
            },
            "existing_debt_service": {
                "table_divs": [
                    {
                        "target": {
                            "header": "existingDebtServiceHeader",
                            "row": "existingDebtServiceRow"
                        },
                        "row_parent": {
                            "class": "row data-row"
                        },
                    }
                ],
                "columns": {
                    "classification": {
                        "config": {
                            "header": {
                                "class": "col",
                            },
                            "row": {
                                "class": "col font-b1"
                            }
                        }
                    },
                    "average_monthly_cash_flow": {
                        "config": {
                            "header": {
                                "class": "col",
                            },
                            "row": {
                                "class": "col"
                            }
                        }
                    },
                    "average_annual_cash_flow": {
                        "config": {
                            "header": {
                                "class": "col",
                            },
                            "row": {
                                "class": "col"
                            }
                        }
                    }
                }
            },
            "dscr_calculations": {
                "table_divs": [
                    {
                        "target": {
                            "header": "dscrCalculationsHeader",
                            "row": "dscrCalculationsRow"
                        },
                        "row_parent": {
                            "class": "row data-row"
                        },
                    }
                ],
                "columns": {
                    "annual_revenue": {
                        "config": {
                            "header": {
                                "class": "col",
                            },
                            "row": {
                                "class": "col font-b"
                            }
                        }
                    },
                    "": {
                        "config": {
                            "header": {
                                "class": "col",
                            },
                            "row": {
                                "class": "col"
                            }
                        }
                    }
                }
            }
        },
        "pdfConfig": {
            "action": "pdf",
            "engine": "document"
        },
        "promiseResolve": promiseResolve
    };

    const processed_data = {
        "consolidated_monthly_activity": {},
        "consolidated_debt_analysis": {},
        "consolidated_trend_analysis": {},
        "consolidated_monthly_line_item": {},
        "ebitda_schedule": {},
        "transactions": {}
    }

    /**
     * main : getting bank-statement html through config file
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     * @param obj object
     */

    const main = (obj) => {
        widgetPromise = new Promise(function (resolve, reject) {
            promiseResolve = resolve;
        });
        initScript.toggleLoader(true, true);
        Object.assign(default_config, obj);
        initApiURL();
        if (default_config["x_resource_list"]) {
            default_config.apiURL.statements.headers["x-resource-list"] = default_config["x_resource_list"];
        }
        getBankStatementInfo();
        return widgetPromise;
    };

    /**
     * initApiURL : initializing URL's
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     * @param data object
     */

    const initApiURL = (data = undefined) => {
        default_config.apiURL = {
            "statements": {
                "type": "POST",
                "url": getV2URL(default_config.widget_service_api, 'statements', default_config.slugs),
                "processData": false,
                "data": data ? data : default_config.body,
                "dataType": "json",
                "headers": {
                    "Content-Type": "application/json"
                }
            }
        };
    };

    /**
     * initOwlCarousel : initializing owl carousel
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     */

    const initOwlCarousel = () => {
        initScript.getHTMLElementByDelimiter("owl-carousel").owlCarousel(default_config.owl_carousel);
    };

    /**
     * getBankStatementInfo : getting bank-statement information as per requirement
     *
     * @author Ahmad Zaman <ahmad.sayeed@biz2credit.com>
     *
     */

    const getBankStatementInfo = () => {
        addProcessBox("Retrieving your case information")
        default_config.security_option = initScript.getObjectValue(default_config, "body.security") || {};
        default_config.defaultOptions = initScript.methodWiseOption(null, default_config.apiURL.statements, default_config.security_option);

        const options = default_config.defaultOptions;
        options.data = JSON.stringify(options.data);
        HttpRequest(options, function (res) {
            delete default_config["x_resource_list"];
            delete default_config.apiURL.statements.headers["x-resource-list"];
            delete default_config.defaultOptions.headers["x-resource-list"]

            if (!!default_config.slugs) {
                res = responseV2Interceptor(res, default_config.slugs['statements']);
            } else {
                res = responseInterceptor(res);
            }
            res = res && res.data ? res.data.data ? res.data.data : res.data : res;
            var errorResponse = false;
            if(initScript.isEmpty(res)){
                errorResponse = { "pdfData": "ERROR", "resource": "NOT_FOUND", "message": "Blank response from service"}
                initScript.toggleLoader(false, true)
                errorBox()
                promiseResolve(errorResponse)
                return
            }
            // start response structuring
            for (var c = 0; c < res.length; c++) {
                processed_data[res[c]["resource"]] = res[c]
                if(initScript.isEmpty(res[c].data)){
                    errorResponse = { "pdfData": "ERROR", "resource": res[c]["resource"], "message": "Data not found"}
                    initScript.toggleLoader(false, true)
                    errorBox()
                    promiseResolve(errorResponse)
                    break;
                }
                else{
                    default_config.bank_statement_info[res[c]["resource"]] = res[c].data;
                }
            }
            if(false === errorResponse) {
                processed_data["account_info"]["data"] = getDistinct(processed_data["account_info"])

                //Month activity graphs        
                const config1 = getBarGraphDataCMA(default_config.charts["consolidated_monthly_activity"].chart1_keys);
                if (config1.is_visible_chart) {
                    processed_data["consolidated_monthly_activity"]["chart1"] = loadChartCMA(config1.data, "graphOne", config1.max);
                }
                const config2 = getBarGraphDataCMA(default_config.charts["consolidated_monthly_activity"].chart2_keys);
                if (config2.is_visible_chart){
                    processed_data["consolidated_monthly_activity"]["chart2"] = loadChartCMA(config2.data, "graphTwo", config2.max, "graph2");
                }
                processed_data["consolidated_monthly_activity"].data[0].summary = processed_data["consolidated_monthly_activity"].data[0].summary.filter(e => e.avg_daily_balance !== 0)


                //debt analysis graphs
                if(default_config.bank_statement_info["consolidated_debt_analysis"][0]["report"] && default_config.bank_statement_info["consolidated_debt_analysis"][0]["report"].length > 0){
                    processed_data.consolidated_debt_analysis["charts"] = [];
                    for(var cda_i = 0; cda_i < default_config.bank_statement_info["consolidated_debt_analysis"][0]["report"].length; cda_i++){
                        var cdaCategory = default_config.bank_statement_info["consolidated_debt_analysis"][0]["report"][cda_i]["category"];
                        var cdadata = restructureDataCDA(default_config.bank_statement_info["consolidated_debt_analysis"][0]["report"][cda_i]["data"])
                        var cda_config = {
                            month: initScript.removeUnexpectedElements(Object.keys(cdadata[0]), ["source", "measure", "total"]),
                            total_sources: (cdadata.length - 3) / 2,
                            width: {
                                chart1: 0
                            },
                            color_codes: ["#158cdc", "#fe9006", "#079e89", "#aa55e8", "#cc2481", "#24da0e", "#dccc0e", "#5794e0", "#4d3a67", "#524c5a", "#8a9eab"]
                        }
                        var cdaconfig = getBarGraphDataCDA(cdadata, cda_config);
                        processed_data.consolidated_debt_analysis["charts"][cda_i] = {};
                        processed_data.consolidated_debt_analysis["charts"][cda_i]["category"] = cdaCategory;
                        processed_data.consolidated_debt_analysis["charts"][cda_i]["legends"] = getCDALegends(cdadata, cda_config)
                        processed_data.consolidated_debt_analysis["charts"][cda_i]["chart1"] = loadChartCDA(cdaconfig.data1, "countOfPaymentsPieChart", cdaconfig.max1, false, cda_config);
                        processed_data.consolidated_debt_analysis["charts"][cda_i]["chart2"] = loadChartCDA(cdaconfig.data2, "debtRepaidPieChart", cdaconfig.max2, true, cda_config);
                    }
                }
                
                //trend analysis
                var ctadata = [];
                ctadata.push({
                    name: "Variable 1",
                    values: selectedResourceDataCTA("revenue")
                });
                ctadata.push({
                    name: "Variable 2",
                    values: selectedResourceDataCTA("expense")
                });
                ctadata.push({
                    name: "Variable 3",
                    values: selectedResourceDataCTA("debt")
                });
                if (ctadata.length){
                    // processed_data.consolidated_trend_analysis["chart1"] = loadChartCTA(ctadata);
                    processed_data.consolidated_trend_analysis["chart1"] = loadBarCTA(ctadata, "revenuecta", "#158cdc", "Variable 1")
                    processed_data.consolidated_trend_analysis["chart2"] = loadBarCTA(ctadata, "expensecta", "#14d899", "Variable 2")
                    processed_data.consolidated_trend_analysis["chart3"] = loadBarCTA(ctadata, "debtcta", "#d82020", "Variable 3")
                }

                //consolidated_monthly_line_item
                var cmlidata = restructureDataCMLI(default_config.bank_statement_info["consolidated_monthly_line_item"])
                var cmlicharts = loadChartCMLI(cmlidata)
                processed_data.consolidated_monthly_line_item["chart1"] = cmlicharts["creditGraph"]
                processed_data.consolidated_monthly_line_item["chart2"] = cmlicharts["debitGraph"]
                var sortOrderTtype = processed_data.consolidated_monthly_line_item["data"]["transactions"].sort(compareValues("transaction_type", "asc"));
                processed_data.consolidated_monthly_line_item["data"]["transactions"] = sortOrderTtype.sort(function (a, b) {
                    if(a.transaction_type === b.transaction_type) return b.average - a.average; /*DESC*/ else return 0
                });


                //transactions
                processed_data.transactions["legends"] = "<li><span style=\"background:#158cdc;\" ></span><label >Expense</label></li><li><span style=\"background:#fe9006;\" ></span><label >Revenue</label></li>";
                processed_data.transactions["chart1"] = loadChartTRNS();
                var accountLevelTrns = [], consolidatedTrns = []
                for (let i = 0; i < processed_data.transactions["data"]["transactions"].length; ++i) {
                    if (!accountLevelTrns[processed_data.transactions["data"]["transactions"][i].account_number]) accountLevelTrns[processed_data.transactions["data"]["transactions"][i].account_number] = [];
                    accountLevelTrns[processed_data.transactions["data"]["transactions"][i].account_number].push(processed_data.transactions["data"]["transactions"][i]);
                }
                for(const [key, element] of Object.entries(accountLevelTrns)){
                        let sortedElement = sortTransactions(element) 
                        consolidatedTrns.push(...sortedElement)
                }
                processed_data.transactions["data"]["transactions"] = sortTransactions(consolidatedTrns);

                //Ebitda
                processed_data.ebitda_schedule["dscr"] = restructureDataDSCR(processed_data["dscr_schedule"].data.report)
                processed_data.ebitda_schedule["chart1"] = loadChartEScurrentdebt()
                processed_data.ebitda_schedule["chart2"] = loadChartESFutureDebt()
                processed_data.ebitda_schedule["data"] = sortClassificationItems(processed_data.ebitda_schedule["data"])

                initScript.toggleLoader(false, true)
                addProcessBox("Creating analysis report", false, true)
                getPDF()
            }
        });
    };

    var getPDF = () => {
        initScript.toggleLoader(true, true)
        let templates = pdfV2Template.main;
        if(!!default_config.pdfTemplate && "object" === typeof default_config.pdfTemplate && !!default_config.pdfTemplate.hbsConfig && "object" === typeof default_config.pdfTemplate.hbsConfig){
            for(const [k,v] of Object.entries(templates.hbsConfig)){
                if(default_config.pdfTemplate.hbsConfig.hasOwnProperty(k) && !!default_config.pdfTemplate.hbsConfig[k] && 'string' === typeof default_config.pdfTemplate.hbsConfig[k]){
                    templates.hbsConfig[k] = default_config.pdfTemplate.hbsConfig[k];
                    default_config.pdfConfig["clientTemplate"] = true;
                }
            }   
        }
        if(!default_config.pdfConfig["clientTemplate"]) templates = {};
        let pdfConfig = default_config.pdfConfig;
        processed_data["businessData"] = pdfConfig["businessData"]
        let options = {
            "type": "POST",
            "url": getV2URL(default_config.widget_service_api, 'summaryV2Pdf', default_config.slugs),
            "processData": false,
            "data": JSON.stringify({ processed_data, templates, pdfConfig }),
            "dataType": "json",
            "headers": {
                "Content-Type": "application/json"
            }
        }
        HttpRequest(options, function (res) {
            if (!!default_config.slugs) {
                res = responseV2Interceptor(res, default_config.slugs['statements']);
            } else {
                res = responseInterceptor(res);
            }
            initScript.toggleLoader(false, true)
            res = res && res.data ? res.data.data ? res.data.data : res.data : res;
            if(res && res.pdfData){
                promiseResolve(res)
                removeProcessBox()
            }
            else{
                let respObj = {"pdfData": "ERROR", "error": res};
                let defaultMessage = "Please Try Again"; 
                if(res.statusText == "failed"){
                    respObj["message"] = (res.actualError && res.actualError.message)?capitalizeFirstLetter(res.actualError.message)+` (${defaultMessage})`: defaultMessage;
                }
                else{
                    respObj["message"] = defaultMessage;
                }
                if(default_config.pdfConfig.logError){ localStorage.setItem("wgt_err_log_v2pdf", JSON.stringify(res)); }
                promiseResolve(respObj)
                errorBox(respObj["message"]) 
            }
        });
    }

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const sortTransactions = (data) => {
        var defaultSortOrder = guessDefaultSortOrder(data)
        return data.sort(function (a, b) {
            var bdateParts = b.transaction_date.split("/");
            var bdateObject = new Date(+bdateParts[2], bdateParts[1] - 1, +bdateParts[0]);
            var adateParts = a.transaction_date.split("/");
            var adateObject = new Date(+adateParts[2], adateParts[1] - 1, +adateParts[0]);
                if(adateObject.toString() === bdateObject.toString()) {
                    return ("DESC" == defaultSortOrder)?-1:1;
                }
                return adateObject - bdateObject; //ASC

                // if(adateObject.toString() === bdateObject.toString()) {
                //     return ("DESC" == defaultSortOrder)?1:-1;
                // }
                // return bdateObject - adateObject; //DESC
        })
    }

    const guessDefaultSortOrder = (data) => {
		var dataSet = data.reduce(function (r, a) {
			r[a.account_number] = r[a.account_number] || [];
			r[a.account_number].push(a);
			return r;
		}, Object.create(null));
		dataSet = dataSet[Object.keys(dataSet)[0]];
		if(!dataSet){
			return "ASC"
		}
		var first = dataSet[0]["transaction_date"].split("/");
		var last = dataSet.find(element => element.transaction_date !== first.join("/"));
		last = (last && last["transaction_date"])?last["transaction_date"].split("/"):first;
		last = new Date(+last[2], last[1] - 1, +last[0]);
		first = new Date(+first[2], first[1] - 1, +first[0]);
		if(first > last) return "DESC"
		return "ASC"
	}

    const getDistinct = (configData) => {
        let array1 = configData.data;
        const acno = [];
        let responseArray = array1.reduce((array1, currentValue) => {
            
            let idx = array1.findIndex(e => e.account_number === currentValue.account_number)
            if (acno.indexOf(currentValue.account_number) === -1) {
                acno.push(currentValue.account_number)
                currentValue["duration_months_actual"] = [];
                currentValue["average_credits"] = (currentValue.no_of_credits < 1) ? 0 : parseFloat((currentValue.credits / currentValue.no_of_credits).toFixed(2))
                currentValue["average_debits"] = (currentValue.no_of_debits < 1) ? 0 : parseFloat((currentValue.debits / currentValue.no_of_debits).toFixed(2))

                currentValue["duration_months_actual"] = getMonthsBetween(stringToDate(currentValue.first_transaction_date), stringToDate(currentValue.last_transaction_date), currentValue["duration_months_actual"])
                currentValue["allMonths"] = getMonthsBetween(stringToDate(currentValue.from_date), stringToDate(currentValue.to_date), [])
                currentValue["missingMonthsCount"] = currentValue["allMonths"].length - currentValue["duration_months_actual"].length;

                currentValue["average_noOfCreditsPerMonth"] = currentValue.no_of_credits / currentValue["duration_months_actual"].length;
                currentValue["average_noOfDebitsPerMonth"] = currentValue.no_of_debits / currentValue["duration_months_actual"].length;
                currentValue["average_amountCreditsPerMonth"] = currentValue.credits / currentValue["duration_months_actual"].length;
                currentValue["average_amountDebitsPerMonth"] = currentValue.debits / currentValue["duration_months_actual"].length;
                currentValue["average_amountPerCreditTransactions"] = currentValue["average_amountCreditsPerMonth"] / currentValue["average_noOfCreditsPerMonth"];
                currentValue["average_amountPerDebitTransactions"] = currentValue["average_amountDebitsPerMonth"] / currentValue["average_noOfDebitsPerMonth"];

                array1.push(currentValue)
            }
            else {
                array1[idx]["no_of_credits"] += currentValue.no_of_credits
                array1[idx]["no_of_debits"] += currentValue.no_of_debits
                array1[idx]["credits"] += currentValue.credits
                array1[idx]["debits"] += currentValue.debits
                array1[idx]["duration_months"] += currentValue.duration_months

                let fromDate1 = stringToDate(array1[idx]["from_date"])
                let fromDate2 = stringToDate(currentValue.from_date)
                array1[idx]["from_date"] = (fromDate2.getTime() < fromDate1.getTime()) ? currentValue.from_date : array1[idx]["from_date"]

                let toDate1 = stringToDate(array1[idx]["to_date"])
                let toDate2 = stringToDate(currentValue.to_date)
                array1[idx]["to_date"] = (toDate2.getTime() > toDate1.getTime()) ? currentValue.to_date : array1[idx]["to_date"]

                array1[idx]["average_credits"] = (array1[idx].no_of_credits < 1) ? 0 : parseFloat((array1[idx].credits / array1[idx].no_of_credits).toFixed(2))
                array1[idx]["average_debits"] = (array1[idx].no_of_debits < 1) ? 0 : parseFloat((array1[idx].debits / array1[idx].no_of_debits).toFixed(2))

                array1[idx]["duration_months_actual"] = getMonthsBetween(stringToDate(currentValue.first_transaction_date), stringToDate(currentValue.last_transaction_date), array1[idx]["duration_months_actual"])
                array1[idx]["allMonths"] = getMonthsBetween(stringToDate(array1[idx]["from_date"]), stringToDate(array1[idx]["to_date"]), [])
                array1[idx]["missingMonthsCount"] = array1[idx]["allMonths"].length - array1[idx]["duration_months_actual"].length;

                array1[idx]["average_noOfCreditsPerMonth"] = array1[idx].no_of_credits / array1[idx]["duration_months_actual"].length;
                array1[idx]["average_noOfDebitsPerMonth"] = array1[idx].no_of_debits / array1[idx]["duration_months_actual"].length;
                array1[idx]["average_amountCreditsPerMonth"] = array1[idx].credits / array1[idx]["duration_months_actual"].length;
                array1[idx]["average_amountDebitsPerMonth"] = array1[idx].debits / array1[idx]["duration_months_actual"].length;
                array1[idx]["average_amountPerCreditTransactions"] = array1[idx]["average_amountCreditsPerMonth"] / array1[idx]["average_noOfCreditsPerMonth"];
                array1[idx]["average_amountPerDebitTransactions"] = array1[idx]["average_amountDebitsPerMonth"] / array1[idx]["average_noOfDebitsPerMonth"];
            }
            return array1
        }, []);

        /* *****Statement Calculations***** */
        var durations = responseArray.map(function(value) {
            return value.duration_months_actual;
        }).join().split(",");
        
        var presentMonth = new Date();
        var lastNmonths = []
        var allMonths = responseArray.map(function(value) {
            return value.allMonths;
        }).join().split(",");
        for(const [key, value] of Object.entries(allMonths)){
            presentMonth = new Date(value);
            lastNmonths.push(new Date(presentMonth.getFullYear(), presentMonth.getMonth(), "01"))
        }
        lastNmonths = lastNmonths.join().split(",")
        durations = [...new Set([...durations, ...lastNmonths])].sort(function(a,b){ return new Date(b)-new Date(a); }); //for 25+ months view

        for(var i = 0; i<responseArray.length; i++){
            var currentValue = responseArray[i];
            currentValue["monthKeys"] = [];
            for(var j = 0; j < durations.length; j++){
                var d_o = new Date(durations[j])
                var pivot = (d_o.getMonth()+1)+"-"+d_o.getFullYear();
                var pivotName = default_config.months[d_o.getMonth()]+"-"+d_o.getFullYear();
                var hay = currentValue["duration_months_actual"].map(function(val){
                    val = new Date(val)
                    return (val.getMonth()+1)+"-"+val.getFullYear()
                })
                var hayAllMonths = currentValue["allMonths"].map(function(val){
                    val = new Date(val)
                    return (val.getMonth()+1)+"-"+val.getFullYear()
                })
                currentValue["monthKeys"].push(pivotName)
                if(-1 !== hay.indexOf(pivot)){
                    currentValue[pivotName] = [
                        "",
                        "Yodlee", 
                        "Manual"]
                        [currentValue["transaction_source"]]
                }
                else{
                    if(-1 !== hayAllMonths.indexOf(pivot)){
                        currentValue[pivotName] = "Missing";
                    }
                    else{
                        currentValue[pivotName] = "NA";
                    }
                }
            }
        } 

        return responseArray
    }

    const getMonthsBetween = (fromDate, toDate, dataArray) => {
        if (undefined === dataArray) dataArray = [];
        var m = fromDate.getMonth() + 1;
        var y = fromDate.getFullYear();
        while (y < toDate.getFullYear() || (y == toDate.getFullYear() && m <= (toDate.getMonth() + 1))) {
            var d_o = new Date(y,m-1,1)
            var pivot = (d_o.getMonth()+1)+"-"+d_o.getFullYear();
            var hay = dataArray.map(function(val){
                val = new Date(val)
                return (val.getMonth()+1)+"-"+val.getFullYear()
            })
            if(-1 === hay.indexOf(pivot)){
                dataArray.push(new Date(y,m-1,1))
            }
            m++;
            if (m > 12) {
                y++;
                m = 1;
            }
        }
        return dataArray;
    }

    const stringToDate = (str) => {
        var dateArray = str.split("/")
        return new Date(dateArray[2], dateArray[1]-1, dateArray[0])
    }

    // Consolidated Monthly Activity
    var getBarGraphDataCMA = (chart_keys) => {
        let max_y_axis = 0, is_visible_chart = false;
        const data = [], keys = Object.keys(chart_keys), data_ar = default_config.bank_statement_info["consolidated_monthly_activity"][0].summary;
        for (let i = Math.max(0, data_ar.length - 12); i < data_ar.length; ++i) {
            const obj = {};
            for (let j = 0; j < keys.length; ++j) {
                const val = data_ar[i][chart_keys[keys[j]]];
                obj[keys[j]] = val;
                if (isNaN(val)) continue;
                obj[keys[j]] = val;
                is_visible_chart = is_visible_chart || !!val;
                obj[keys[j] + "_is_neg"] = +obj[keys[j]] < 0;
                obj[keys[j]] = Math.abs(+obj[keys[j]]);
                max_y_axis = Math.max(max_y_axis, obj[keys[j]]);
            }
            data.push(obj);
        }
        return { data, max: max_y_axis, is_visible_chart };
    };
    var loadChartCMA = (data, target_id, max_y_axis, type = "graph1") => {
        var barcontainer = document.createElement("div");
        barcontainer.setAttribute("id", target_id)
        const chart_config = default_config.charts["consolidated_monthly_activity"];
        const lineData = []; var isLine = false;
		if(type == "graph1"){
			isLine = true;
			data.forEach(function(v){
				lineData.push({"model_name": v.model_name, "field3":v.field3}) 
				delete v.field3; delete v.field3_is_neg 
			});
		}
        Object.assign(chart_config, {
            "max_y_axis": max_y_axis,
            "id": "#" + target_id,
            "width": 500,
            "isLine": isLine,
			"lineData": lineData,
            "data": data,
            "is_doller_format": true,
            "tooltip": {
                "left": -42,
                "diff_class": "graph",
            }
        });
        bindColorCodes(chart_config, default_config["_consolidated_monthly_activity"][type].color_codes);
        return barinit(chart_config, barcontainer);
    };
    const bindColorCodes = (config, ar) => {
        config.color = { bars: {} };
        for (let i = 0; i < ar.length; ++i) config.color.bars["field" + (i + 1)] = ar[i];
    };

    // Consolidated Debt Analysis
    function getCDALegends(cdadata, conf) {
        conf.sources = []
        for (let i = 0; i < cdadata.length - 3; i += 2) conf.sources.push(cdadata[i].source);
        let html_legends = "";
        for (let i = 0; i < conf.sources.length; ++i) {
            let html = initScript.bindAttrsOnHTMLTag("span", "", {
                "style": { "background": conf.color_codes[i] }
            }) + initScript.bindAttrsOnHTMLTag("label", conf.sources[i]);
            html_legends += initScript.bindAttrsOnHTMLTag("li", html);
        }
        return html_legends
    }
    function restructureDataCDA(data_arr) {
        const resp = [];
        let data = data_arr.summary, obj1, obj2, obj3;
        for (let i = 0; i < data.length; ++i) {
            obj1 = {
                total: data[i]["total_count"],
                measure: "Count",
                source: data[i].source
            };
            obj2 = {
                total: data[i]["total_amount"],
                measure: "Amount",
                source: ""
            };
            for (let j = 0; j < data[i]["monthly_report"].length; ++j) {
                obj1[data[i]["monthly_report"][j].month] = data[i]["monthly_report"][j].count;
                obj2[data[i]["monthly_report"][j].month] = data[i]["monthly_report"][j].amount;
            }
            resp.push(obj1);
            resp.push(obj2);
        }

        data = data_arr["aggregated_month_report"];
        obj1 = {
            total: data_arr["total_debt_count"],
            measure: "<b>Count</b>",
            source: "<b>Total</b>"
        };
        obj2 = {
            total: initScript.separateNumberByDelimiterWithSignAndThousand(data_arr["total_debt"]),
            measure: "<b>Amount</b>",
            source: ""
        };
        obj3 = {
            total: data_arr["percentage_of_total_revenue"] + "%",
            measure: "",
            source: "<b>Percentage of Calculated Annual Revenue</b>"
        };
        for (let i = 0; i < data.length; ++i) {
            obj1[data[i].month] = "<b>" + data[i].count + "</b>";
            obj2[data[i].month] = "<b>" + initScript.separateNumberByDelimiterWithSignAndThousand(data[i].amount) + "</b>";
            obj3[data[i].month] = "<b>" + data[i]["percentage_of_calculated_revenue"] + "%" + "</b>";
        }
        resp.push(obj1);
        resp.push(obj2);
        resp.push(obj3);
        return resp;
    }
    const getBarGraphDataCDA = (data, conf) => {
        var _cda_config = conf;
        let max1 = 0, max2 = 0, data1 = [], data2 = [];
        for (let i = Math.max(0, _cda_config.month.length - 12); i < _cda_config.month.length; ++i) {
            const obj1 = { "model_name": _cda_config.month[i] }, obj2 = { "model_name": _cda_config.month[i] };
            let field_count = 1;
            for (let j = 0; j < data.length - 3; j += 2) {
                const amount = initScript.formatedNumberToValidNumber(data[j + 1][_cda_config.month[i]]);
                max1 = Math.max(max1, data[j][_cda_config.month[i]]);
                max2 = Math.max(max2, amount);
                obj1["field" + field_count] = data[j][_cda_config.month[i]];
                obj2["field" + field_count++] = amount;
            }
            data1.push(obj1);
            data2.push(obj2);
        }
        return { data1, max1, data2, max2 }
    }
    const loadChartCDA = (data, target_id, max_y_axis, is_doller_format = false, conf) => {
        // initScript.innerHTMLToATarget(initScript.getHTMLElementByDelimiter(target_id, "#"), "");
        var barcontainer = document.createElement("div");
        barcontainer.setAttribute("id", target_id)
        const chart_config = default_config.charts["consolidated_debt_analysis"];
        // const dd = $(".monthly-summery").height() + ($("header").length ? (30 + $("header").height()) : 0) + ($(".mainnav").length ? $(".mainnav").height() : 0);
        Object.assign(chart_config, {
            "max_y_axis": max_y_axis,
            "id": "#" + target_id,
            "width": 1024, //_default_config.width.chart1,
            "data": data,
            "is_doller_format": is_doller_format,
            "tooltip": {
                // "top": dd - 10,
                "left": (is_doller_format ? 0 : 1) * 15,
                "diff_class": "graph",
                "diff": true
            }
        });
        const tick_values = [0], tick_origin_value = max_y_axis / 5;
        if (!is_doller_format) {
            for (let i = 0; i < 4; ++i) tick_values.push(Math.floor((max_y_axis < 6) ? i : (tick_values[tick_values.length - 1] + tick_origin_value)));
            tick_values.push(Math.floor(max_y_axis));
            chart_config.tick_values = initScript.uniqueData(tick_values);
        }
        else if (chart_config.hasOwnProperty("tick_values")) delete chart_config.tick_values;
        for (let i = 0; i < conf.total_sources; ++i)
            chart_config.color.bars["field" + (i + 1)] = conf.color_codes[i];
        return barinit(chart_config, barcontainer);
    };

    // Consolidated Trend Analysis
    var selectedResourceDataCTA = (type) => {
        var resp = [];
        var data = default_config.bank_statement_info["consolidated_trend_analysis"][0].summary;
        var my = "month_year";
        for (var i = 0; i < data.length; i++) {
            var block = { "date": templateEvents.dateToYearMonthFormat(data[i][my]), "price": data[i][type], "from": "left" }
            resp.push(block);
        }
        return resp
    }
    var loadChartCTA = (data) => {
        var linecontainer = document.createElement("div");
        linecontainer.setAttribute("id", "ctagraph")
        const chart_config = default_config.charts["consolidated_trend_analysis"];
        // const dd = initScript.getHTMLElementByDelimiter("monthly-summery").height() + (initScript.getHTMLElementObject("header").length ? (30 - 10 + initScript.getHTMLElementObject("header").height()) : 0) + (initScript.getHTMLElementByDelimiter("mainnav").length ? initScript.getHTMLElementByDelimiter("mainnav").height() : 0);
        Object.assign(chart_config, {
            "width": 1024,
            "margin": 1024 * 0.045,
            "tooltip": {
                "diff": true,
                // "top": dd,
                // "left": +(window.innerWidth - initScript.getHTMLElementByDelimiter("trend-analysis-graph").width()) / 2,
            },
            "color": ["#178CDC", "#00CB96", "#DC0000"],
            "resource": default_config["consolidated_trend_analysis"],
            "data": data
        });
        return lineinit(chart_config, linecontainer);
    };

    var loadBarCTA = (data, target_id, color = "#158cdc", variableName="Variable 1") => {
        var barcontainer = document.createElement("div");
        barcontainer.setAttribute("id", target_id)

		var barConfig = {
			"x_axis": "model_name",
			"barWidth": 1,
			"height": 320,
			"margin": { "top": 20, "right": 10, "bottom": 20, "left": 50 },
			"bar_padding": 0.5,
			"bar_margin": 10,
			"axis_ticks": { "qty": 12, "outer_size": 0 },
			"color": { "bars": { "field1": color} },

			"max_y_axis": 0,
			"id": "#"+target_id,
			"width": 750, //checkout
			"data": [],
			"is_doller_format": true,
		};
		var gdata = [], variable1 = data.filter(e => e.name == variableName);
		if(variable1.length > 0){
			for (const v of variable1[0].values) {
				var xaxis = new Date(v.date+"-1")
				xaxis = default_config.months[xaxis.getMonth()]+"-"+xaxis.getFullYear()
				gdata.push({ "model_name": xaxis, "field1": Math.abs(parseFloat(v.price)), "field1_is_neg": (parseFloat(v.price) < 0)});
				barConfig.max_y_axis = (barConfig.max_y_axis > Math.abs(parseFloat(v.price)))?barConfig.max_y_axis:Math.abs(parseFloat(v.price));
            }
        }
		barConfig.data = gdata;

        return barinit(barConfig, barcontainer);
	}

    // Consolidated Monthly Line Item
    var restructureDataCMLI = (data) => {
        const resp = [];
        for (let i = 0; i < data['transactions'].length; ++i) {
            const obj = {
                "transaction": data['transactions'][i]['transaction_type'].replace(data['transactions'][i]['transaction_type'][0], data['transactions'][i]['transaction_type'][0].toUpperCase()),
                "category": data['transactions'][i]['category']
            };
            for (let j = 0; j < data['transactions'][i]['months'].length; ++j) obj[data['transactions'][i]['months'][j]['month']] = data['transactions'][i]['months'][j]['value'];
            obj['average'] = data['transactions'][i]['average'];
            resp.push(obj);
        }
        // return resp
        var sortOrder1 = resp.sort(compareValues("transaction", "asc"));
        var sortOrder2 = sortOrder1.sort(function (a, b) {
            if(a.transaction === b.transaction)
            return b.average - a.average; //DESC
            else
            return 0
          });
          return sortOrder2;
    };

    function compareValues(key, order = 'asc') {
        return function innerSort(a, b) {
          if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
            // property doesn't exist on either object
            return 0;
          }
      
          const varA = (typeof a[key] === 'string')
            ? a[key].toUpperCase() : a[key];
          const varB = (typeof b[key] === 'string')
            ? b[key].toUpperCase() : b[key];
      
          let comparison = 0;
          if (varA > varB) {
            comparison = 1;
          } else if (varA < varB) {
            comparison = -1;
          }
          return (
            (order === 'desc') ? (comparison * -1) : comparison
          );
        };
      }

    function getChartDataCMLI(cmlidata, category = "credit") {
        const data = cmlidata, resp = [];
        var old_data = default_config.bank_statement_info["consolidated_monthly_line_item"];
        for (let i = 0; i < old_data.months.length; ++i)
            resp.push({ "price": 0, "date": templateEvents.dateToYearMonthFormat(old_data.months[i]) });

        for (let i = 0; i < data.length; ++i) {
            if (data[i].transaction.toLowerCase() !== category) continue;
            for (let j = Math.max(0, old_data.months.length - 12); j < old_data.months.length; ++j)
                resp[j].price += data[i][old_data.months[j]];
        }
        return resp;
    }

    function loadChartCMLI(cmlidata) {
        const config = default_config.charts["consolidated_monthly_line_item"].config;
        // const dd = initScript.getHTMLElementByDelimiter("monthly-summery").height() + (initScript.getHTMLElementObject("header").length ? (30 + initScript.getHTMLElementObject("header").height()) : 0) + (initScript.getHTMLElementByDelimiter("mainnav").length ? initScript.getHTMLElementByDelimiter("mainnav").height() : 0);
        config.width = 500 * 0.92;
        config.margin = 500 * 0.08;
        config.data[0].values = getChartDataCMLI(cmlidata, "debit");
        config.tooltip.left = (window.innerWidth - initScript.getHTMLElementByDelimiter("hideShowSection1").width()) / 2;
        // config.tooltip.top = dd + 16 - 10 - 25;
        config.tooltip.diff_class = "graph";
        config.tooltip.diff = true;
        config.color = ["#00CB96"]

        const config1 = default_config.charts["consolidated_monthly_line_item"].config1;
        config1.width = 500 * 0.92;
        config1.margin = 500 * 0.08;
        config1.tooltip.left = config.tooltip.left + 10 + initScript.getHTMLElementByDelimiter("hideShowSection1 .row .col-6").width() + 30;
        // config1.tooltip.top = config.tooltip.top;
        config1.tooltip.diff_class = "graph";
        config1.tooltip.diff = true;
        config1.data[0].values = getChartDataCMLI(cmlidata);
        config1.color = ["#178CDC"]

        var linecontainer = document.createElement("div");
        linecontainer.setAttribute("id", "monthlyLineItemDebitChart")
        let debitGraph = lineinit(config, linecontainer);
        var linecontainer2 = document.createElement("div");
        linecontainer2.setAttribute("id", "monthlyLineItemCreditChart")
        let creditGraph = lineinit(config1, linecontainer2);

        return { debitGraph, creditGraph }
        // analyserV2.resolvePromise();
    }

    // High Value Transactions
    var loadChartTRNS = () => {
        var data = default_config.bank_statement_info["transactions"];
        var chart_config = default_config.charts["transactions"]
        chart_config.data = [
            {
                "value": Math.abs(data.expense),
                "label": "Consolidated"
            },
            {
                "value": Math.abs(data.revenue),
                "label": "Consolidated"
            }
        ];
        var donutcontainer = document.createElement("div");
        donutcontainer.setAttribute("id", "highvaluetransactionsTRNS")
        return donutinit(chart_config, donutcontainer)
    }

    // Ebitda DSCR Schedule
    var restructureDataDSCR = (inputData) => {
        let dscrDataConfig = {}
        dscrDataConfig["data"] = []
        Object.assign(dscrDataConfig["data"], inputData);
        const groups = ["Revenue", "Est. Operating Profit", "Debt Service", "DSCR"];

        for (let i = 0; i < dscrDataConfig.data.length; ++i) {

            const group = dscrDataConfig.data[i].group;
            dscrDataConfig[group] = {};
            dscrDataConfig.data[i]["groupName"] = groups[i];
            if (i === 2 && !isNaN(dscrDataConfig.data[i]["yearly"])) {
                dscrDataConfig["current_debt"] = typeCastedValue(dscrDataConfig.data[i]["yearly"]);
            }
            if (i === 1 && !isNaN(dscrDataConfig.data[i]["yearly"])) dscrDataConfig.est_operating_profit = Number(dscrDataConfig.data[i]["yearly"]);
            for (let j = 0; j < 1; ++j) {
                dscrDataConfig[group]["yearly"] = 0;
                let _val = dscrDataConfig.data[i]["yearly"];
                if (!isNaN(_val)) dscrDataConfig[group]["yearly"] = _val = (i === 3) ? _val : typeCastedValue(_val);
            }
        }

        dscrDataConfig["stated_revenue"] = (default_config.body["config"]["ebitda_schedule"]["gross_annual_revenue"]) ? default_config.body["config"]["ebitda_schedule"]["gross_annual_revenue"] : 0;
        dscrDataConfig["percentageOfStated"] = (((Number(default_config.bank_statement_info["ebitda_schedule"]['revenue']['annual_flow']) - Number(dscrDataConfig["stated_revenue"])) / (Number(default_config.bank_statement_info["ebitda_schedule"]['revenue']['annual_flow']) > 0 ? default_config.bank_statement_info["ebitda_schedule"]['revenue']['annual_flow'] : 1)) * 100).toFixed(2)
        return dscrDataConfig;
    }
    const typeCastedValue = val => Number((Math.abs(val)).toFixed(2));

    function sortClassificationItems(data){
        data.expense.items = data.expense.items.sort(function (a, b) {
            if(a.name == b.name) return 0;
            if(a.name == "Net Transfer" || a.name == "Net Returns and Refunds"){
                return 1
            }
            if(b.name == "Net Transfer" || b.name == "Net Returns and Refunds"){
                return -1
            }
            return b.amount - a.amount; //DESC
        });
        data.revenue.items = data.revenue.items.sort(function (a, b) {
            return b.amount - a.amount; //DESC
        });
        data.debt.items = data.debt.items.sort(function (a, b) {
            return b.amount - a.amount; //DESC
        });
        return data;
    }

    var loadChartEScurrentdebt = () => {
        var esData = default_config.bank_statement_info["ebitda_schedule"]
        var dscrData = default_config.bank_statement_info["dscr_schedule"].report

        var gdata = {};
        gdata.revenue = dscrData.find(o => o.group == "revenue");
        gdata.operating_profit = dscrData.find(o => o.group == "operating_profit")
        gdata.operating_expense = typeCastedValue(gdata.revenue.yearly) - typeCastedValue(gdata.operating_profit.yearly);
        var current_debt_chart_config = {
            id: ".ebitdaLeftGraph",
            width: 500,
            margin: { top: 20, right: 30, bottom: 30, left: 60 },
            neg_y_axis: (gdata.operating_profit.yearly < 0 ) ? true : false,
            data: [
                {
                    "name": "Revenue",
                    "value": initScript.roundOff(typeCastedValue(gdata.revenue.yearly)),
                    "class": "revenue_rect",
                    "color": "#2da5e7",
                    "start": 0,
                    "end": Math.abs(typeCastedValue(gdata.revenue.yearly)),
                },
                {
                    "name": "Operating Costs",
                    "value": initScript.roundOff(gdata.operating_expense),
                    "class": "operating_expense_rect",
                    "color": "#fcab25",
                    "start": Math.abs(typeCastedValue(gdata.operating_profit.yearly)),
                    "end": Math.abs(typeCastedValue(gdata.revenue.yearly)),
                },
                {
                    "name": "Operating Profit",
                    "value": initScript.roundOff(gdata.operating_profit.yearly),
                    "class": "est_operating_profit_rect",
                    "color": "#6d64f4",
                    "start": 0, //Math.abs(gdata.operating_expense),
                    "end": (gdata.operating_profit.yearly < 0)? gdata.operating_profit.yearly : Math.abs(typeCastedValue(gdata.operating_profit.yearly)),
                },
            ]
        };
        var waterfallcontainer = document.createElement("div");
        waterfallcontainer.setAttribute("id", "ESCurrentDebit")
        return waterfallinit(current_debt_chart_config, waterfallcontainer);
    };

    function loadChartESFutureDebt(flag = false) {

        var esData = default_config.bank_statement_info["ebitda_schedule"]
        var dscrData = default_config.bank_statement_info["dscr_schedule"].report
        var gdata = {};
        gdata.revenue = dscrData.find(o => o.group == "revenue");
        gdata.operating_profit = dscrData.find(o => o.group == "operating_profit")
        gdata.current_debt = dscrData.find(o => o.group == "debt")
        gdata.operating_expense = typeCastedValue(gdata.revenue.yearly) - typeCastedValue(gdata.operating_profit.yearly);

        const est_operating_profit = initScript.roundOff(typeCastedValue(gdata.operating_profit.yearly));
        const current_debt = initScript.roundOff(Math.max(0, typeCastedValue(gdata.current_debt.yearly)));
        const current_debt_value = initScript.roundOff(current_debt * 1.25);
        const current_debt_margin = initScript.roundOff(current_debt * 1.25 - current_debt);
        let future_debt = initScript.roundOff(gdata.future_debt = est_operating_profit - current_debt - current_debt_margin);
        let future_debt_value = initScript.roundOff((est_operating_profit - current_debt - current_debt_margin) / (1.25));
        let future_debt_margin = initScript.roundOff(future_debt - future_debt_value);

        if( (current_debt+current_debt_margin) > gdata.operating_profit.yearly){
            future_debt = 0;
            future_debt_value = 0;
            future_debt_margin = 0;
        }

        const chart_config_with_abs = {
            current_debt: Math.abs(current_debt),
            est_operating_profit: Math.abs(est_operating_profit),
            current_debt_margin: Math.abs(current_debt_margin),
            current_debt_value: Math.abs(current_debt_value),
            current_debt_margin_start: ((future_debt_value < 0)? 0: Math.abs(future_debt_value)) + ((future_debt_value < 0)? 0: Math.abs(future_debt_margin)) + Math.abs(current_debt),
            current_debt_margin_end: ((future_debt_value < 0)? 0: Math.abs(future_debt_value)) + ((future_debt_value < 0)? 0: Math.abs(future_debt_margin)) + Math.abs(current_debt) + Math.abs(current_debt_margin),
            future_debt: Math.abs(future_debt),
            future_debt_value: Math.abs(future_debt_value),
            future_debt_margin: Math.abs(future_debt_margin),
            future_debt_margin_end: Math.abs(current_debt) + Math.abs(current_debt_margin) + Math.abs(future_debt_value) + Math.abs(future_debt_margin),
            future_debt_margin_start: Math.abs(current_debt) + Math.abs(current_debt_margin) + Math.abs(future_debt_value)
        };

        processed_data.ebitda_schedule["dscr"]["debtAmount"] = future_debt_value;
        processed_data.ebitda_schedule["dscr"]["updatedDSCR"] = (gdata.operating_profit.yearly / (current_debt + future_debt_value)).toFixed(2)

        var future_debt_chart_config = {
            id: ".ebitdaRightGraph",
            "is_fixed_axis": true,
            width: 500,//initScript.getHTMLElementByDelimiter("ebitdaRightGraph").width(),
            margin: { top: 20, right: 30, bottom: 30, left: 40 },
            neg_y_axis: true,
            data: [
                {
                    "name": "Est. Operating Profit",
                    "value": (gdata.operating_profit.yearly >= 0)?est_operating_profit: -1*est_operating_profit,
                    "class": "est_operating_profit_rect1",
                    "color": "#837bf8",
                    "start": 0,
                    "end": chart_config_with_abs.est_operating_profit,
                },
                {
                    "name": "Current Debt Capacity",
                    "value": current_debt,
                    "class": "current_debt_rect",
                    "color": "#42cbd5",
                    "start": (future_debt_value < 0) ? 0 : chart_config_with_abs.future_debt_value + chart_config_with_abs.future_debt_margin,
                    "end": chart_config_with_abs.current_debt_margin_start
                },
                {
                    "name": "Future Debt Capacity",
                    "value": future_debt_value,
                    "class": "future_debt_rect_" + (future_debt_value >= 0 ? "positive" : "negative") + "_values future_debt_rect",
                    "color": "#800000",
                    "start": 0,
                    "end": (future_debt_value < 0) ? -1 * chart_config_with_abs.future_debt_value : (chart_config_with_abs.future_debt_margin_start - Math.abs(current_debt) - Math.abs(current_debt_margin))
                },
                {
                    "name": "",
                    "value": current_debt_margin,
                    "class": "margin_current_debt_rect",
                    "color": "gray",
                    "start": (current_debt_margin < 0)? -1 * (chart_config_with_abs.current_debt_value) : chart_config_with_abs.current_debt_margin_start,
                    "end": (current_debt_margin < 0)? -1 * (chart_config_with_abs.current_debt) : chart_config_with_abs.current_debt_margin_end,
                    "parent": 3
                },
                {
                    "name": "",
                    "value": future_debt_margin,
                    "class": "margin_future_debt_rect",
                    "color": "gray",
                    "parent": 2,
                    "start": future_debt_margin < 0 ? -1 * chart_config_with_abs.future_debt_value : (chart_config_with_abs.future_debt_margin_start - Math.abs(current_debt) - Math.abs(current_debt_margin)),
                    "end": future_debt_margin < 0 ? -1 * chart_config_with_abs.future_debt : (chart_config_with_abs.future_debt_margin_end - Math.abs(current_debt) - Math.abs(current_debt_margin))
                }
            ]
        };
        if( 0 > gdata.operating_profit.yearly){
            future_debt_chart_config.data = []
        }
        var waterfallcontainer = document.createElement("div");
        waterfallcontainer.setAttribute("id", "ESFutureDebit")
        return waterfallinit(future_debt_chart_config, waterfallcontainer);
    }

    //Graph Gen
    var loadedGraph = (containerData) => {
        let svgElement = containerData._groups[0][0].children[0];
        var s = new XMLSerializer().serializeToString(svgElement)
        var encodedData = "data:image/svg+xml;base64," + window.btoa(s);
        // document.getElementById("svgImg").setAttribute("src", encodedData)
        // var old = document.querySelector(".consolidated_monthly_activity").innerHTML;
        // document.querySelector(".consolidated_monthly_activity").innerHTML = old + (containerData._groups[0][0].innerHTML)
        return { "data_url": encodedData, "html": containerData._groups[0][0].innerHTML }
    }

    var barinit = (config, barcontainer) => {
        const bars = Object.keys(config.color.bars), colors = [], container = d3.select(barcontainer),
            { width, height, margin, bar_padding, axis_ticks } = config,
            svg = container.append("svg").attr("width", width).attr("height", height).append("g").attr("transform", `translate(${margin.left}, ${margin.top})`);
        for (let i = 0; i < bars.length; ++i) colors.push(config.color.bars[bars[i]]);
        const is_doller_format = config.is_doller_format || false;
        let old_data = [];
        Object.assign(old_data, config.data);
        const x_scale_0 = d3.scaleBand().range([0, width - margin.left - margin.right]).padding(bar_padding),
            x_axis = d3.axisBottom(x_scale_0).tickFormat(function (d) {
                const date = d.toString().split("-");
                return date[0] + "-" + date[1] % 100;
            }).tickSizeOuter(axis_ticks.outer_size),
            y_scale = d3.scaleLinear().range([height - margin.top - margin.bottom, 0]),
            y_axis = d3.axisLeft(y_scale);
        if (config.max_y_axis > 0) y_axis.ticks(5);
        else y_axis.tickValues([0, 100]);

        if (!!config.tick_values) y_axis.tickValues(config.tick_values);

        y_axis.tickFormat(d => is_doller_format ? initScript.separateNumberByDelimiter(d / 1000) : Math.trunc(d)).tickSizeOuter(axis_ticks.outerSize);
        let x_scale_1 = d3.scaleBand();

        x_scale_0.domain(config.data.map(d => d[config.x_axis]));
        x_scale_1.domain(bars).range([0, x_scale_0.bandwidth()]);
        y_scale.domain([0, config.max_y_axis + 1]);

        const graph = svg.selectAll("." + config.x_axis)
            .data(config.data)
            .enter()
            .append("g")
            .attr("class", config.x_axis)
            .attr("transform", d => `translate(${x_scale_0(d[config.x_axis])} , 0)`);
        for (let i = 0; i < bars.length; ++i) {
            graph
                .selectAll(".bar." + bars[i]).data(d => [d])
                .enter()
                .append("rect")
                .attr("rx", 5)
                .attr("ry", 3)
                .attr("class", "bar " + bars[i])
                .attr("width", 6)
                .on("mouseover", function (d, j) {
                    const tooltip_value = (d[bars[i] + "_is_neg"] ? -1 : 1) * d[bars[i]];
                    tooltipSection.transition()
                        .duration(200)
                        .style("opacity", .9);
                    tooltipSection.html(is_doller_format ? initScript.separateNumberByDelimiter(tooltip_value / 1000) : tooltip_value)
                        .style("left", (d3.event.pageX + config.tooltip.left - (config.tooltip.diff ? (+initScript.getHTMLElementByDelimiter("hideShowSection1 .col-6").width() - +initScript.getHTMLElementByDelimiter("graph").width()) : 0)) + "px")
                        .style("top", (height - margin.top + margin.bottom - +d3.select(this).attr("height") + +config.tooltip.top) + "px")
                        .style("display", "block")
                        .style("color", d[bars[i] + "_is_neg"] ? "red" : colors[i])
                        .style("border-color", d[bars[i] + "_is_neg"] ? "red" : colors[i])
                        .append("span")
                        .style("border-color", d[bars[i] + "_is_neg"] ? "red" : colors[i])
                })
                .on("mouseout", function (d) {
                    tooltipSection.html(" ")
                        .style("display", "none");
                })
                .style("fill", d => config.color.bars[bars[i]])
                .attr("x", d => x_scale_1(bars[i]))
                .attr("y", d => y_scale(0))
                .attr("height", d => height - margin.top - margin.bottom - y_scale(0))
                .attr("y", d => y_scale(0))
                .attr("height", d => height - margin.top - margin.bottom - y_scale(0))
        }

        for (let i = 0; i < bars.length; ++i) {
            graph
                .selectAll(".bar." + bars[i]).data(d => [d])
                // .transition()
                // .duration(1200)
                // .delay(200)
                .style("fill", d => config.color.bars[bars[i]])
                .attr("width", 6)
                .attr("y", d => y_scale(d[bars[i]]))
                .attr("height", d => height - margin.top - margin.bottom - y_scale(d[bars[i]] || 0))
        }

        if(config.isLine){
			var line = d3.line()
			// console.log(config.id)
			let lines = svg.append("path")
			.datum(config.lineData)
			.attr("fill", "none")
			.attr("stroke", config.color.bars["field3"])
			.attr("stroke-width", 3)
			.attr("d", line
			.x(function(d) { 
				return x_scale_0(d.model_name) })
			.y(function(d) { return y_scale(d.field3) })
			);

			svg.selectAll("circle-group")
			.data(config.lineData).enter()
			.append("g")

			.style("fill", config.color.bars["field3"])
			
			.selectAll("circle")
			.data(config.lineData).enter()
			.append("g")
			.style("cursor", "pointer")
			.attr("class", "circle")
			.append("circle")
			.attr("cx", d => {
				// console.log(d);
				return x_scale_0(d.model_name)})
			.attr("cy", d => y_scale(d.field3))	

			.attr("r", 5)
			.style('opacity', 1)
		}

        svg.append("g").attr("class", "x axis").attr("transform", `translate(0, ${height - margin.top - margin.bottom})`).call(x_axis);
        svg.append("g").attr("class", "y axis").call(y_axis);
        const tooltipSection = d3.select("body").append("div")
            .attr("class", "tooltip")
            .style("opacity", 0);

        return loadedGraph(container)
    };

    var lineinit = (config, linecontainer) => {
        const { width, height, margin, color, duration, lineOpacity, circleOpacity, circleRadius } = config, gredientHeight = height - margin;
        /* Format Data */
        const parseDate = d3.timeParse("%Y-%m");
        config.data.forEach(function (d) {
            d.values.forEach(function (d) {
                d.date = parseDate(d.date);
                d.price = +d.price;
            });
        });
        const tooltip = d3.select("body")
            .append('div')
            .attr('class', 'tooltip');

        const areaFunction = d3.area()
            .x(d => xScale(d.date))
            .y0(gredientHeight)
            .y1(d => yScale(d.price));
        if (config.curve) areaFunction.curve(d3.curveMonotoneX);
        /* Scale */
        const xScale = d3.scaleLinear()
            .domain(d3.extent(config.data[0].values, d => d.date))
            .range([0, width - margin]);
        let mx = 0, mn = 0;
        for (let i = 0; i < config.data.length; ++i) {
            mn = Math.min(d3.min(config.data[i].values, d => d.price), mn);
            mx = Math.max(d3.max(config.data[i].values, d => d.price), mx);
        }
        const yScale = d3.scaleLinear()
            .domain([0, mx + (mx < 5 ? 10 : 1)])
            .range([height - margin, 0]);

        /* Add SVG */
        const container = d3.select(linecontainer), svg = container
            .append("svg")
            .attr("width", (width + margin) + "px")
            .attr("height", (height + margin) + "px")
            .append('g')
            .attr("transform", `translate(${margin}, ${margin})`);
        var area_gradient = {};
        for (let i = 0; i < config.data.length; ++i) {
            const color = config.color[i];
            area_gradient["field" + i] = svg.append('defs')
                .append("linearGradient")
                .attr('id', "field" + i)
                .attr("x1", "0%").attr("y1", "0%")
                .attr("x2", "0%").attr("y2", "100%")
                .selectAll("stop")
                .data([
                    { offset: "0%", color: color, opacity: 0.2 },
                    { offset: "30%", color: color, opacity: 0.1 },
                    { offset: "40%", color: color, opacity: 0.1 },
                    { offset: "40%", color: color, opacity: 0.1 },
                    { offset: "100%", color: color, opacity: 0.4 }
                ])
                .enter().append("stop")
                .attr("offset", function (d) { return d.offset; })
                .attr("stop-color", function (d) { return d.color; })
                .attr("stop-opacity", function (d) { return d.opacity; })
        }
        /* Add line into SVG */
        const line = d3.line()
            .x(d => xScale(d.date))
            .y(d => yScale(d.price));

        if (config.curve) line.curve(d3.curveMonotoneX);
        let lines = svg.append('g')
            .attr('class', 'lines');



        for (let i = 0; i < config.data.length; ++i) {
            const resp = [];
            for (let j = 0; j < config.data[i].values.length; ++j) {
                resp.push({
                    date: config.data[i].values[j].date,
                    price: config.data[i].values[j].price
                });
            }
            lines.selectAll('.line-group').data(config.data).enter()
                .append("path")
                .attr("class", "area")
                .style("fill", `url(#field${i})`)
                .attr("d", areaFunction(resp));
        }
        let repeat = () => {
            var data = d3.range(11).map(function () { return Math.random() * 10 })



            const total_length = d3.select("path").node().getTotalLength();
            d3.selectAll("path")
                .attr("stroke-dasharray", total_length + " " + total_length)
                .attr("stroke-dashoffset", total_length)
                .transition()
                .duration(4000)
                .ease(d3.easeLinear)
                .attr("stroke-dashoffset", 0)
                .on("end", repeat);
        };

        lines.selectAll('.line-group')
            .data(config.data)
            .enter()
            .append('g')
            .attr('class', 'line-group1');
        // const totalLength = svg.select(".line-group1").node().getTotalLength();
        lines.selectAll('.line-group1')
            .append('path')
            .style("opacity", "0")
            .attr('class', 'line')
            .transition()
            .duration(400)
            .style("opacity", "1")

            .transition()
            .duration(400)
            .attr('d', d => line(d.values))
            .style('stroke', (d, i) => color[i])
            .style('opacity', lineOpacity)

        lines.selectAll('.line-group')
            .transition()
            .duration(duration);



        /* Add circles in the line */
        lines.selectAll("circle-group")
            .data(config.data).enter()
            .append("g")

            .style("fill", (d, i) => color[i])
            .selectAll("circle")
            .data(d => d.values).enter()
            .append("g")
            .style("cursor", "pointer")
            .attr("class", "circle")
            .on("mouseover", function (d, i) {
                const idx = (d.from === "left" || config.data[0].from === "left") ? 0 : 1;
                // if (!!config.callback && !!config.resource) resources[config.resource][config.callback](d, d.from);
                const dd = (config.tooltip.diff === true) ? (initScript.getHTMLElementByDelimiter("hideShowSection1 .row").height() - initScript.getHTMLElementByDelimiter(config.tooltip.diff_class ? config.tooltip.diff_class : "card-body").height()) : 0;
                tooltip.html(initScript.separateNumberByDelimiter(d.price / 1000));
                tooltip
                    .style('top', (+this.children[0].getAttribute("cy") + config.tooltip.top + dd) + 'px')
                    .style('left', (+this.children[0].getAttribute("cx") + config.tooltip.left) + 'px')
                    .style("position", "absolute")
                    .style('display', 'block')
                    .style('color', color[idx])
                    .style('font-weight', 'bold')
                    .style('border-color', color[idx])
                    .style('opacity', 0.7)
                    .append("span")
                    .style("border-color", color[idx]);
            })
            .on("mouseout", function (d) {
                tooltip.style('display', 'none')
            })

            .append("circle")
            .attr("cx", d => xScale(d.date))
            .attr("cy", d => yScale(d.price))

            .attr("r", circleRadius)
            .style('opacity', circleOpacity)
            .on("mouseout", function (d) {
                d3.select(this)
                    .transition()
                    .duration(duration)
                    .attr("r", circleRadius);
            });


        /* Add Axis into SVG */
        const xAxis = d3.axisBottom(xScale).ticks(d3.timeMonth.every(1)).tickFormat(d3.timeFormat("%b-%y"));
        const yAxis = d3.axisLeft(yScale).ticks(mx < 5 ? 1 : Math.min(5, config.data[0].values.length)).tickFormat(function (d) {
            return initScript.separateNumberByDelimiterWithSignAndThousand(d);
        });

        svg.append("g")
            .attr("class", "x axis")
            .attr("transform", `translate(0, ${height - margin})`)
            .call(xAxis);

        svg.append("g")
            .attr("class", "y axis")
            .call(yAxis)
            .append('text')
            .attr("y", 15);

        return loadedGraph(container)

    }

    var donutinit = (config, donutcontainer) => {
        const { width, height, data } = config;
        var center = 1;

        const container = d3.select(donutcontainer)
        const svg = container.append('svg').attr("width", width)
            .attr("height", height)
            .append("g");

        svg.append("g")
            .attr("class", "slices");
        svg.append("g")
            .attr("class", "labels");
        svg.append("g")
            .attr("class", "lines");
        const radius = Math.min(width, height) / 2;
        const color = d3.scaleOrdinal(["#158cdc", "#fe9006",]);
        const pie = d3.pie().value(d => d.value);
        const arc = d3.arc().innerRadius(radius * 0.65).outerRadius(radius * 0.6).cornerRadius(2);

        const outerArc = d3.arc()
            .outerRadius(radius * 0.9)
            .innerRadius(radius * 0.9);


        var outterBorder = svg.selectAll("g.outter-arc")
            .data(pie(data))
            .enter()
            .append("g")
            .attr("class", "outter-arc")
            .attr("width", width)
            .attr("transform", "translate(" + center + ", " + center + ")");

        var outerBorderThickness = d3.arc()
            .innerRadius(120)
            .outerRadius(150);




        svg.attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

        svg.selectAll('path')
            .data(pie(data))

            .enter()
            .append('path')

            .attr('d', arc)
            .attr('fill', (d, i) => color(i))
            .transition()

            .duration(800)
            .attrTween('d', function (d) {
                var i = d3.interpolate(d.startAngle + 0.0, d.endAngle);
                return function (t) {
                    d.endAngle = i(t);
                    return arc(d)
                }
            })
            ;
        // svg.append('g').classed('labels',true);
        // svg.append('g').classed('lines',true);



        var polyline = svg.select('.lines')
            .selectAll('polyline')
            .data(pie(data))
            .enter().append('polyline')
            .attr('points', function (d) {

                // see label transform function for explanations of these three lines.
                var pos = outerArc.centroid(d);
                pos[0] = radius * 0.95 * (midAngle(d) < Math.PI ? 1 : -1);
                return [arc.centroid(d), outerArc.centroid(d), pos]
            });



        var label = svg.select('.labels').selectAll('text')
            .data(pie(data))
            .enter().append('text')
            .attr('dy', '.35em')
            .attr('class', "account-text")
            .text(function (d) {
                return initScript.separateNumberByDelimiterWithSignAndThousand(d.data.value);
            })
            .attr('transform', function (d) {
                var pos = outerArc.centroid(d);
                pos[0] = radius * 0.95 * (midAngle(d) < Math.PI ? 1 : -1);
                return 'translate(' + pos + ')';
            })
            .style('text-anchor', function (d) {
                return (midAngle(d)) < Math.PI ? 'start' : 'end';
            });



        svg.append('text')
            .attr('class', 'toolCircle account-text')
            .attr('dy', 0) // hard-coded. can adjust this to adjust text vertical alignment in tooltip
            .text(function (d, i) {
                return data[i].label;
            }) // add text to the circle.
            .style('font-size', '1em')
            .style('text-anchor', 'middle');

        function midAngle(d) { return d.startAngle + (d.endAngle - d.startAngle) / 2; }
        outterBorder.append("path")
            .attr("fill", 'rgba(44, 162, 241, 0.08)')
            .attr("d", outerBorderThickness).style('stroke', 'white')
            .style('stroke-width', 0);

        return loadedGraph(container)
    }

    var waterfallinit = (config, waterfallcontainer) => {
        let { margin, width, data, neg_y_axis } = config;
        width = width - margin.left - margin.right;
        const height = 200, padding = 0.2;

        const x = d3
            .scaleBand()
            .rangeRound([0, width])
            .padding(padding);

        const y = d3
            .scaleLinear()
            .domain([neg_y_axis ? -1 * d3.max(data, (d) => d.end) : 0, d3.max(data, (d) => d.end)])
            .range([height, 0]);

        const xAxis = d3.axisBottom(x);

        const yAxis = d3
            .axisLeft(y)
            .ticks(3, "f")
            // .tickValues([0, 100000, 1000000])
            .tickPadding(3);
        /*.tickFormat((d) => {
            return initScript.separateNumberByDelimiter(d);
        });*/
        const container = d3.select(waterfallcontainer)
        const chart = container
            .append("svg")
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
            .append('g')
            .attr('transform', `translate(${margin.left}, ${margin.top})`);

        x.domain(data.map((d) => d.name));

        chart
            .append('g')
            .attr('class', 'x axis x_axis_private')
            .attr('transform', `translate(0, ${config.neg_y_axis ? (height / 2) : height})`)
            .call(xAxis);

        chart
            .append('g')
            .attr('class', 'y axis')
            .call(yAxis);

        const bar = chart.selectAll('.bar')
            .data(data.reverse())
            .enter().append('g')
            .attr('class', (d) => {
                return `bar ${d.class}`;
            })
            .attr('transform', (d, i) => {
                return `translate(${x(!!d.parent ? data[d.parent].name : d.name)}, 0)`;
            })
            .attr('fill', (d) => { return d.color });

        if (config.neg_y_axis) {
            chart.selectAll('.x_axis_private g line')
                .style("display", "none");

            chart.selectAll('.x_axis_private g text')
                .attr('transform', `translate(0, ${height / 2})`);
        }

        bar
            .append('rect')
            .attr('y', (d) => y(Math.max(d.start, d.end)))
            .attr('height', (d) => Math.abs(y(d.start) - y(d.end)))
            .attr('width', x.bandwidth());

        bar.append("text")
            .attr("x", function (d) {
                return x.bandwidth() / 2
            })
            .attr("y", function (d) {
                if (config.neg_y_axis && d.class !== "est_operating_profit_rect1") {
                    if(d.class === "current_debt_rect" && d.value < 0) return height / 2 - 10;
					if(d.class === "current_debt_rect") return height / 2 - 7 

					if(d.class.split(" ").indexOf("future_debt_rect_negative_values") !== -1) return height / 2 - 10;
					if(d.class.split(" ").indexOf("future_debt_rect_positive_values") !== -1) return height / 2 + 10;

                    if(d.class === "margin_future_debt_rect" && d.value < 0) return height -10; 
					if(d.class === "margin_future_debt_rect") return -10;
					
					if(d.class === "margin_current_debt_rect" && d.value < 0) return height - 10;
					if(d.class === "margin_current_debt_rect") return -10;
                }
                return (y(Math.max(d.start, d.end)) - 10);
            })
            .style("fill", "black")
            .attr("dy", ".35em")
            .html(d => {
                if (d.value === 0) return "";
                return initScript.separateNumberByDelimiterWithSign(d.value).replace(/[kK]/, "");
            })

        return loadedGraph(container)
    }

    const resolvePromise = (data) => {
        promiseResolve({
            "code": 200,
            "data": data
        });
    };

    function addProcessBox(base = "Generating PDF", follow = false, update=false) {
        if(default_config.pdfConfig.hideNotifyBox) return
        if(!follow){
            if(!!default_config.pdfConfig && !!default_config.pdfConfig.businessData && !!default_config.pdfConfig.businessData.businessName)
            follow = "for <b>"+default_config.pdfConfig.businessData.businessName+"</b>";
        }
        if(update){
            removeProcessBox();
        }
        var animation = "<style>@keyframes spin {0% { transform: rotateY(0deg); }100% {  transform: rotateY(359deg); }}.v2star {animation: spin 2s linear infinite; width: 24px; margin-right:5px;}</style>"; 
        var srcBase64 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAANvElEQVRoQ71aCXCU5Rl+/muPZDebEBITEhJQI4cgQlWUIwFsRRGLV6m0torWqfVAq8UKCmpHph5pi47jAYNTrTiaTQWhxQpiEuTUoNxCQE0CIQkkkGPv/+q83/f/u0uQrSwz3ZkF9t/d73+f93nf532+bxFw5ofw66FF/ZSo4Un+SDjphduV4tvf85bi8GrG2FGBJUv83Wf3zRRBplhIrr/12rf7e1zXaKYJCAJM04QECYIoQTdNmGCX2R+i/e8zLKgDMAWYYcXV+6Ur5+PFpjhvx+LFXecKhG5/pofv81umrizxeSe1d3ezQHN8WQiFI4jEYvBmeuByOsCxCRQc2GJnWJHA6oYBVdXQ481G6+gJq+syPb96fubMc2IjFYC8jTOmVJdk+8q/aT8ORRJRkp+H7mAQx7q7ke/zIScrCwbjwYqcQAjCaUDoE8SeYZqIGQZ6Q2EYV05GePS4latWrbi9srIymC4TqQHcUFFdkp1VfqCtHYXZ/VipOBQHWjqOI8ebiX6+LIsBur14CgUEhJDQXwTAMEwGVjNM9ITDOJ6RjQt+Px8tHR3+d5cvv3PJkiWhdECkBnB9RXWxz1Pe0HYMpfl5ONjahoF5/RGOqhAFAeflZsPqBBYoy73ImoI/k9ig7BMA1TAQiMbQHNEwcsEiZJxXhF07dyybOnXqvQC0swWREsCG6ydWF2d5y7vCUWQ5negMBtAdCaM0Lw9RVYM3IzNRPfGMC7yMBDEOjrDYLMRMHYGohu+6ujHmT5UYMHIUWltasGvXrpdmzJjxKLXK2YBICaBu6vjq0mxvecw0WXYpqKhuwKkIECSmO+wpCBILmhMgQDdU1qxudwYgEhDAMOlpIqYbCKoavunsxOinXkDZVeMQCodwtOUo6uvrK2fNmvX42YBIBaB/3TVXVJdk+SpiuskCEUQ7u1QdIkyBQuPXWbkIEkzdwGGXG3rxYGR9ux8FigiDVIrqwzQQ1YCgGsOhjhMYvfDPGDqxgiU8FAqhqakJ27Zte2727Nnzqe9/CBMpAXw65YrqQT5PRYwtZQXZBwhrXpEDoexTNpW7HoIsCujdVIvs5gZAdrBy0mAioukIqjoaj3dgzNMvoMwCQHeIaioaDjRg2xdfPH3P7NnPnDOA9ZPHVJdmeStihmnVtcRlhbJ9GhAwJoKaCc/vHkXTymp4ohH0D5yAIUksnbphIqITAA2dwSBw0cUQC4thKgokxQnJ4YAjOxuq223sbj76yCMP3v/S/wKRkoG1E0dbDLCZywIUBdGavgSGEs/B2NcjugHvA4+jaesmZHUeg7f5EKA42OQmCY0YOkKaioCqs5kSjEagGiZo2lOfiLIC34BiYGCpvj2oPvy3119/JRWI1AAmjKwu9XgrorCa2GpckfUCASHtt/SeAREQjUTgmfMkerq7gY3r4W35DoaswBAA1QDCuoGIpiGs66yhdVDgJLACa3L6HPWRW1LQkdM/vCYmTPf7/Z+eCURKAB9fNby6xOutUG27wJqVAqeSIk9EjPDGhsAZ0cJBuO+eg37jy9G0aAE87UdgSgqbxKwHDBNRCp6yTsPNGnYUIDHApjYTBhMetxv7FU/V3W+/N4ve/j4QKQF8NHaYv8STMYnGPxk4USTptCaulXHOhK1OlOYYUH4tiu+dg4P33wFvLASD1AkmSMyolEiWdSvjCXGgyGltgwGhnGQ6HGiNxmqm/nPtTwEEzhrAmsvKGIAoLUgBW5pP9c4mLgGyJjDNBQZE19AzaAguevJZ7HtgNs4zDegimT1u+Mj8USpZOi33ZyfBai6un4KJDIeCo72huvIV624GcOKsAfxr9IX+Eo9rEskoKxMWsABRlHj/WiVFZQW6JprQQgGo027D5XPnYfPT85G1+RM4MrN4aRAAa36w9VhCqHe4l+L3sK0I4JYVHA4E6sZ/sO5WAB1nDWD1yFJ/sSdjEusBK8N8YHEGeP3boHhTnwiFUPria5B1A3C7cOAP96LYk8kYIJDUrMx621LM1uA+iq1l+UK64lRkNPeE6savTBPAyhFF/pIM96QYX571AQ/eDoBf4xIrQtBUnBg8DJcuqkTDg/eg7Onn8PVHq+FY8z68vn6MBQLNI+bA46VpJ4htjPiUd0oEIFA3flVNegysvLjQX+R2TSL5YzeiIJnhkVkM1NTsZiIgiRJ6erqQ+2QlcrK8aJt3P1zjrkbBo09gy2NzcF7LN/BkUSlZ6yQDoWuS3WO2NQFckoym3kDd+NW16QH44OI8f5HLzUuIatQaZnYJCQIHwgaZoaM9uxBXLXsHjc/Mh7mvniQH/W//LTKn3YAtC+cj8+vtyPZ6WAOz/hUlyLIMp8NpmT4+JLksC3ApMpp6gnUT12xID0D1sP7+IrdjkkZFy3a93O9wA8epppuJgoxA5CRy5j6PwpJSND/6G0gOJyKxKHqjPcj5xUMYcsds7P9wBY5t2gBkeqC4XHwr2tsDo/EgimQTLiedElilJQAuWUJTd6iufO3GNAEM7181wKVMplHP9+62habMEyfcyImmjmPZRZjwVhX2zH0Inbu2Qh9YBveQEcgZNhw5BQUoHDIUsqLAWTyQKdE3tTUQwiE43G6osozWZa8i72QbsxI2A6wHAqG6irWb0wPw/vDcqgFODoApJu+AU4DIgoCTaghFTy5G5oAi7H37TRSOuAQ5Xg/M9nag4xiiR5qgHm+FoUWQecmV8F09FUZuPk60taLjUAMycnPh2v0lpAM7ISiOOLNuWUZzMFhXse7z9AC8NzS3qtClTGbHKvb2xTp9kGjjYpo4qeowB4/BlDfeRNOrL0M/uB9aezP0Xi7b1CeipECQZAiSBKgqTFOHI78YrrKhcBUWI9ZxDKGvtrLyJHbs2eCSRMbAlJov0wOwfGhu1QCXbDFgZd86/wloBnpzzodYUoLR99wHc+9utC5dBGJEEBwQIJ/SJ+Sd7BnCpZN8hQ7B1Nl+QXK4+JC0p7wgwC1LaA6E667ecI4AolRC1hikzHerOsTx01EwYiTCwTCGXzcNe+6cDlkwWMY5VCuTljFLbDu59NKTWStrFvBpTn3Ft6f0nktS0BgM112zcUd6DLw1JKeqyOVgDDDVEwACY46dhhG3zMTWxS/ixy+/hkMLH0PkwOf29sCSXO5YQUyw0wmegoR6kfUgaU6a8mweWJOdZFSWcSQQqv3Jlr0/S8tK/H1ITlWB1cR0I5Z9zYnLli7HtsoXMO6JBTj54Uq0f7gMCiuLxMEcG3TxpicgXMEYE2yeWJY87mQlvu+2X4siXLKI5mCs9rpt6QHIXXZRjr/QqUymZrUfSn4ZyhYugqnpCG3egOaq15KCt32NdV5hmXUOjILjwZ9aXol5wvcaifIiGT0SCtVeV38wLQYYgAKnPFkzLJNooXB7i5gvDgeOMla4tCZ8GDdm/LW94eAybAOhT9isWABYORErVskRA5KEw5FI7fTth9IDsOTCbL8to5b5jTORHGDyjODSmRS4Beb08rLsMzWtZUFZ9ll5cVCsB0LR2ht2fnduANiphBW6HRy3FDxQvuW3GDhl4MUPGS27nHhtf4dZ8rhicVb4PYgBEUdjau0NO5vSA/DqBcSAPFljZi6pQftm2aajz2d4cInystewSyx1eUlwiAJaI7HaG/e2pA+AeoD2sPY+wz4+jzOSBCY5MDvDNoCEDTm9V+LAkvqEbWgkCUcjau3Ne9vSA/Dy+T6/bebs2rbLJp5du7T6AOn7eft71PR9+4TpknWdxNYGTwBaI2rNrfuOz0xnDuQSAGKA7wdOVRW7F3iG+ZmOHSTZiaSfPbhS2QvYnsqaK8lgbKGw12YlFNVqZu7rSA/AYhuANYnje9c+A4uCkIZPhFI4AEYohOjm1XCUXQF50GCIsozQ3t0Qj+yGnDsY0qjLIbqcMBv2A9/W93G5p5aXkwDE1Jqf7+tMH0C+g5o4kd1ExqyfkiwwU9d8ga4dX8E3ciQaP/4PCsdeCa2rC+GmRhTedAs2zbkPRePGo2DCRLSuWoVAwz50fvVpSvUiBtojWs1t+9ME8Nfzff58h8QGWbKM2sOAnYBwg4BrVm7CruoqDLvpZpzcUIfsMT9C43vv4uC/38Gk55fCdLrQ1XAAnlGXYsfSNyDuWM8muP1IqjB+5ERNbJXQL9MFUDnI689PshJ2zvuCodfXrtgINRzCifov8PVLCzBh+cf47p1/YO+qt3DVwsXw5eXh+J49GDzjRhzbsgXfvlKJYKAVUlx5Tp/eLlFEe1Sruf1AmgzYAGw3mjx9EwXEbcb0dV/hy2eeQuOGD5l+X/vBBjRu346WnTsw5Y/zsHveXHgvHwsl04P6Zx+GW2Ib0njjJ0QhAYSVUFStuePASZLRzjhdSf9IZq7v+7kEIM+hTFaTzFzficzng4BR9y/A4dUr0Nm8hwEafscj6Dd0GPRIBG3r16Fx4yoMqrgJokNB0yf+eOZtObYVLBmILAJtUa3m7oY0AfxlcNaKAqcykU6R+z6SZZHes37M5yeD1mv7W3RNSZJW2wDGg06aIcmAiIGWiPrZXQ0nb0qHgX5PFGe+6JOliaphkkk54yOZxkSZndqgdq0nL5JgM+Gr2H7G+pBDEPQuTf/sscbeuekc7tJ/8igFMBCA44f+6JYK6A8s3eQlYgAOA2hK53idesxpBZ+qV35gzGl9jKqQQETT+YEjrTv+v7/0X6e0GHz1ro1HAAAAAElFTkSuQmCC";
        if(default_config.pdfConfig.action == "spreadsheet" || default_config.pdfConfig.action == "csv"){
            srcBase64 = "data:image/svg+xml;base64,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";
        }
        var im = animation+"<img class=\"v2star\" src=\""+srcBase64+"\">"
        var demo = document.createElement("div");
        demo.setAttribute("id", "process-message")
        demo.style.display = "block";
        demo.setAttribute("onclick", "document.getElementById(\"process-message\").style.display=\"none\"")
        demo.setAttribute("style", "z-index:999999999999999; position: fixed;width: 500px;border: 1px solid green;border-radius: 3px;text-align: center;margin: 2% 30%;padding: 12px 8px;background: rgba(137,240,118,0.3);font-size: 14px;font-weight: 400;cursor:pointer;")
        demo.innerHTML = im + base + " " + follow;
        document.body.appendChild(demo)
    }
    function removeProcessBox() {
        if(default_config.pdfConfig.hideNotifyBox) return
        var myobj = document.getElementById("process-message");
        myobj.remove();
    }
    function errorBox(msg) {
        var demo = document.getElementById("process-message");
        demo.style.backgroundColor = "rgba(240,137,118,0.3)";
        demo.style.textAlign = "justify";
        demo.innerHTML = "&nbsp;&nbsp;&nbsp;&nbsp; "+(("undefined" !== typeof msg)?msg:"Could not retrieve information for this case.")+" &nbsp;&nbsp;&nbsp;&nbsp;<strong style='float:right;'>[X]</strong></b>"
        var opacity=1;
        var intervalID=setInterval(function(){opacity>0?(opacity-=.01,demo.style.opacity=opacity):(clearInterval(intervalID),demo.remove())},40);
    }

    return {
        main,
        init_owl_carousel: initOwlCarousel,
        resolvePromise
    };
}();
